/** Namespace `reminders` — wird befüllt während der Komponenten-Migration. */
export const reminders = {
  de: {
    reminders: {
      none: '—',
      noEmailValue: 'keine E-Mail',
      statusSent: 'Gesendet',
      statusFailed: 'Fehler',
      statusSkipped: 'Übersprungen',
      statusPending: 'Ausstehend',
      filterAll: 'Alle',
      loadError: 'Fehler beim Laden',
      settingsSaved: 'Einstellungen gespeichert.',
      saveError: 'Speichern fehlgeschlagen',
      runDone: 'Lauf abgeschlossen: {{sent}} gesendet, {{skipped}} übersprungen, {{failed}} Fehler.',
      runError: 'Lauf fehlgeschlagen',
      reminderSent: 'Erinnerung an {{name}} gesendet.',
      sendNotPossible: 'Versand nicht möglich',
      sendError: 'Versand fehlgeschlagen',
      title: 'Erinnerungen',
      automaticBadge: 'Automatisch',
      checkAndSendNow: 'Jetzt prüfen & senden',
      reload: 'Neu laden',
      settings: 'Einstellungen',
      settingsIntro:
        'Automatische Erinnerungen werden nur an Termine mit Status <1>bestätigt</1> verschickt, in der Sprache des Termins (Muttersprache + Englisch). Der Versand läuft stündlich (Zeitzone Europe/Madrid).',
      automaticActive: 'Automatische Erinnerungen aktiv',
      leadTimes: 'Vorlaufzeiten',
      beforeAppointment: 'vor dem Termin',
      saving: 'Speichern…',
      save: 'Speichern',
      adminOnlyHint: 'Diese Einstellungen können nur von Administratoren geändert werden.',
      upcomingTitle: 'Bevorstehende bestätigte Termine',
      upcomingCount: '{{count}} Termine (nächste 8 Tage)',
      loadingShort: 'Lädt…',
      noUpcoming: 'Keine bevorstehenden bestätigten Termine.',
      colPatient: 'Patient',
      colAppointment: 'Termin',
      colLanguage: 'Sprache',
      colIn: 'In',
      colReminders: 'Erinnerungen',
      hoursUntil: '{{hours}}h',
      tierSent: '✓ gesendet',
      tierSkipped: 'übersprungen',
      tierDue: 'fällig',
      tierPlanned: 'geplant',
      noEmailTitle: 'Keine E-Mail-Adresse',
      sendNowTitle: 'Jetzt senden',
      sending: '…',
      send: 'senden',
      logTitle: 'Protokoll',
      noLog: 'Noch keine Erinnerungen protokolliert.',
      colTimestamp: 'Zeitpunkt',
      colRecipient: 'Empfänger',
      colLeadTime: 'Vorlauf',
      colTrigger: 'Auslöser',
      colStatusDetails: 'Status / Details',
      tier24h: '24 Std.',
      tier7d: '1 Woche',
      triggerManual: 'Manuell',
      triggerAutomatic: 'Automatisch',
    },
  },
  es: {
    reminders: {
      none: '—',
      noEmailValue: 'sin correo electrónico',
      statusSent: 'Enviado',
      statusFailed: 'Error',
      statusSkipped: 'Omitido',
      statusPending: 'Pendiente',
      filterAll: 'Todos',
      loadError: 'Error al cargar',
      settingsSaved: 'Configuración guardada.',
      saveError: 'Error al guardar',
      runDone: 'Ejecución finalizada: {{sent}} enviados, {{skipped}} omitidos, {{failed}} errores.',
      runError: 'Error en la ejecución',
      reminderSent: 'Recordatorio enviado a {{name}}.',
      sendNotPossible: 'Envío no posible',
      sendError: 'Error en el envío',
      title: 'Recordatorios',
      automaticBadge: 'Automático',
      checkAndSendNow: 'Comprobar y enviar ahora',
      reload: 'Recargar',
      settings: 'Configuración',
      settingsIntro:
        'Los recordatorios automáticos solo se envían a citas con estado <1>confirmada</1>, en el idioma de la cita (lengua materna + inglés). El envío se ejecuta cada hora (zona horaria Europe/Madrid).',
      automaticActive: 'Recordatorios automáticos activos',
      leadTimes: 'Tiempos de antelación',
      beforeAppointment: 'antes de la cita',
      saving: 'Guardando…',
      save: 'Guardar',
      adminOnlyHint: 'Esta configuración solo puede ser modificada por administradores.',
      upcomingTitle: 'Próximas citas confirmadas',
      upcomingCount: '{{count}} citas (próximos 8 días)',
      loadingShort: 'Cargando…',
      noUpcoming: 'No hay próximas citas confirmadas.',
      colPatient: 'Paciente',
      colAppointment: 'Cita',
      colLanguage: 'Idioma',
      colIn: 'En',
      colReminders: 'Recordatorios',
      hoursUntil: '{{hours}}h',
      tierSent: '✓ enviado',
      tierSkipped: 'omitido',
      tierDue: 'pendiente',
      tierPlanned: 'programado',
      noEmailTitle: 'Sin dirección de correo electrónico',
      sendNowTitle: 'Enviar ahora',
      sending: '…',
      send: 'enviar',
      logTitle: 'Registro',
      noLog: 'Aún no hay recordatorios registrados.',
      colTimestamp: 'Momento',
      colRecipient: 'Destinatario',
      colLeadTime: 'Antelación',
      colTrigger: 'Disparador',
      colStatusDetails: 'Estado / Detalles',
      tier24h: '24 h',
      tier7d: '1 semana',
      triggerManual: 'Manual',
      triggerAutomatic: 'Automático',
    },
  },
};
